import axios from "axios";
import { uAPI } from "./Config";
import Swal from "sweetalert2";

const api = new axios.create();

// Add a request interceptor
api.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const credentials = btoa(
      process.env.REACT_APP_BASIC_AUTH_USERNAME +
        ":" +
        process.env.REACT_APP_BASIC_AUTH_PASSWORD
    );
    const basicAuth = "Basic " + credentials;
    config.headers.Authorization = basicAuth;

    return config;
  },
  function (error) {
    // Do something with request error
    console.error("Request error:", error.message); // new add
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // console.log("Error response interceptor: ", error.response.data);
      // console.log("Error response interceptor: ", error.response.status);
      // console.log("Error response interceptor: ", error.response.headers);
      console.error(
        "Server error:",
        error.response.status,
        error.response.data
      );
      /*Swal.fire({
        title: "Error",
        text: "Terjadi kesalahan pada server. Silakan coba lagi nanti.",
        icon: "error",
        confirmButtonText: "OK",
      });*/
      // Preserve the original error response data so callers can read the
      // server's message payload even when the HTTP status code is non-2xx
      // (e.g. validation errors returned with statusCode 500).
      return Promise.resolve({
        data: error.response.data,
        status: error.response.status,
        statusText: error.response.statusText,
        headers: error.response.headers,
      });
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      // console.log("Error response interceptor: ", error.request);
      console.error("No response received:", error.request);
      /*Swal.fire({
        title: "Error",
        text: "Terjadi kesalahan pada server. Silakan coba lagi nanti.",
        icon: "error",
        confirmButtonText: "OK",
      });*/
      return Promise.resolve({ data: null });
    } else {
      // Something happened in setting up the request that triggered an Error
      // console.log("Error response interceptor: ", error.message);
      console.error("Request setup error:", error.message);
      /*Swal.fire({
        title: "Error",
        text: "Terjadi kesalahan pada server. Silakan coba lagi nanti.",
        icon: "error",
        confirmButtonText: "OK",
      });*/
    }
    // console.log("Error response interceptor: ", error.config);

    // return Promise.reject(error);
    return Promise.resolve({ data: null });
  }
);

// const apiGet = (url = '', params = null) => {
//     return api.get(uAPI + url, {
//         params,
//     })
// }
const apiGet = (url = "", params = null, basePath = uAPI) => {
  return api.get(basePath + url, {
    params,
  });
};

const apiPost = (url = "", data = null, config = null) => {
  return api.post(uAPI + url, data, config);
};

const apiPut = (url = "", data = null, config = null) => {
  return api.put(uAPI + url, data, config);
};

const apiDelete = (url = "", data = null) => {
  return api.delete(uAPI + url, {
    data,
  });
};

const Get = (url = "", params = null) => {
  return api.get(url, {
    params,
  });
};

const Post = (url = "", data = null, config = null) => {
  return api.post(url, data, config);
};

const Put = (url = "", data = null, config = null) => {
  return api.put(url, data, config);
};

const Delete = (url = "", data = null) => {
  return api.delete(url, {
    data,
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
// example usage: api.apiGet()
export default {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
  Get,
  Post,
  Put,
  Delete,
};
